export default __webpack_public_path__ + "static/illustration-content.url-2df64633b57730965a9920f99c44bf25.svg";